import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LayoutDashboard, Sparkles, MessageSquareText, Calendar, Menu } from "lucide-react";

export const MobileBottomTabs = ({ badges = {} }) => {
  const { t } = useTranslation();
  const items = [
    { to: "/dashboard", label: t("sidebar.dashboard"), icon: LayoutDashboard, key: "dashboard" },
    { to: "/dashboard/matches", label: t("sidebar.matches"), icon: Sparkles, key: "matches", badgeKey: "newMatches" },
    { to: "/dashboard/gesprekken", label: t("sidebar.gesprekken"), icon: MessageSquareText, key: "gesprekken", badgeKey: "newGesprekken" },
    { to: "/dashboard/agenda", label: t("sidebar.agenda"), icon: Calendar, key: "agenda" },
    { to: "/dashboard/profiel", label: t("sidebar.more"), icon: Menu, key: "more" },
  ];
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 bg-white border-t border-slate-200 z-30" data-testid="mobile-bottom-tabs">
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const Icon = it.icon;
          const badge = it.badgeKey ? badges[it.badgeKey] : null;
          return (
            <NavLink key={it.key} to={it.to} end={it.to === "/dashboard"}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium relative ${
                  isActive ? "text-[#F5A623]" : "text-slate-500"
                }`
              }
              data-testid={`bottom-tab-${it.key}`}>
              <Icon size={20} />
              <span>{it.label}</span>
              {badge ? (
                <span className="absolute top-1 right-1/4 bg-[#F5A623] text-white text-[10px] font-bold rounded-full px-1.5 py-px">{badge}</span>
              ) : null}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};
